import React from 'react';
import { Button, Card, CardBody, FormGroup, Input, Label } from 'reactstrap';
import CancelButton from '../../../common/CancelButton';
import { PropTypes } from 'prop-types';

const RefillForm = ({
  comments,
  onChangeComments,
  isSaving,
  onSave,
  errors
}) => {

  return (
    <Card>
      <CardBody>
        {errors.onSave && (
          <div className="alert alert-danger" role="alert">
            {errors.onSave}
          </div>
        )}
        <FormGroup>
          <Label for="comments">Komentarz</Label>
          <Input
            type="textarea"
            name="text"
            id="comments"
            value={comments}
            onChange={onChangeComments}
            style={{height: 100}}
          />
        </FormGroup>
        <Button
          color="success"
          type="submit"
          disabled={isSaving}
          onClick={onSave}
        >
          <i className="fa fa-check" />&nbsp;
          { isSaving ? "Zapisywanie..." : "Zatwierdź" }
        </Button>
        {' '}
        <CancelButton />
      </CardBody>
    </Card>
  );
}

RefillForm.propTypes = {
  comments: PropTypes.string.isRequired,
  onChangeComments: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  onSave: PropTypes.func,
  errors: PropTypes.object
}

export default RefillForm;
